import { SHOW_DELETE_ACCOUNT_NOTIFICATION } from '@/store/redux/actions/pages/home';
import { IReduxActionProps } from '@/store/redux/Utils';

export interface HomeState {
  showDeleteNotification: {
    [key: string]: boolean;
  };
}

export const initialHomeState: HomeState = {
  showDeleteNotification: {
    value: false,
  },
};

const reducer = (
  state: HomeState = initialHomeState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SHOW_DELETE_ACCOUNT_NOTIFICATION: {
      return {
        showDeleteNotification: {
          value: action.payload?.show,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
